export const getTextYesNo = (isCheck: boolean) => (isCheck ? "YES" : "NO")
